module.exports = __webpack_public_path__ + "static/selesnya-e4d0940649102d6d9f8d73b58b802527.jpg";